<template>
 <div>
  编辑属性:
 </div>
</template>

<script>
 export default {
   name: 'clickCheck',
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style>

 
</style>



// WEBPACK FOOTER //
// src/components/home/components/components/edit/editProperties.vue